import React from 'react'
import { useSelector } from 'react-redux'

import I18n from 'lib/i18n'
import railsContext from 'lib/selectors/rails-context'

import PressMobile from './press-mobile'
import PressTabletOrDesktop from './press-tablet-or-desktop'

import { pressSvgs } from './press-svgs'

const languageUrlSwitchForPress = languageUrl => {
  switch (languageUrl) {
    case 'fr-be':
      return [0, 2, 7, 3].map(svgIndex => pressSvgs[svgIndex])
    case 'fr-ch':
      return [2, 5, 1, 4].map(svgIndex => pressSvgs[svgIndex])
    case 'fr-lu':
      return [2, 1, 4, 3].map(svgIndex => pressSvgs[svgIndex])
    default:
      return [2, 1, 4, 6].map(svgIndex => pressSvgs[svgIndex])
  }
}

export default function Press () {
  const { languageUrl } = useSelector(railsContext)

  return (
    <div className='press-container'>
      <div id='press-logos'>
        <h3 className='header'>{I18n.t('layouts.footer.in_press')}</h3>
        <PressMobile languageUrl={languageUrl} languageUrlSwitchForPress={languageUrlSwitchForPress} />
        <PressTabletOrDesktop languageUrl={languageUrl} languageUrlSwitchForPress={languageUrlSwitchForPress} />
      </div>
    </div>
  )
}
